import { useEffect, useState } from "react";
import { API_BASE } from "config/api";
import { getAuthToken } from "utils/cookies";

export const useIsLoggedIn = () => {
  const [isLoggedIn, setIsLoggedIn] = useState<boolean>(false);

  useEffect(() => {
    let isCancelled = false;

    const verifyAuth = async () => {
      const authToken = getAuthToken();
      const userId = localStorage.getItem("userId");

      if (!authToken || !userId) {
        if (!isCancelled) {
          setIsLoggedIn(false);
        }
        return;
      }

      try {
        const response = await fetch(`${API_BASE}/users/profile/${userId}`, {
          headers: {
            Authorization: `Bearer ${authToken}`,
            "Content-Type": "application/json",
          },
          credentials: "include",
        });

        if (!isCancelled) {
          setIsLoggedIn(response.ok);
        }
      } catch (error) {
        if (!isCancelled) {
          setIsLoggedIn(false);
        }
      }
    };

    verifyAuth();

    const syncAuthState = () => {
      verifyAuth();
    };

    document.addEventListener("visibilitychange", syncAuthState);

    const handleCookieChange = (event: CookieChangeEvent) => {
      const authCookieChanged = event.changed.some(
        (cookie) => cookie.name === "authToken"
      );
      const authCookieDeleted = event.deleted.some(
        (cookie) => cookie.name === "authToken"
      );

      if (authCookieChanged || authCookieDeleted) {
        verifyAuth();
      }
    };

    if ("cookieStore" in window) {
      cookieStore.addEventListener("change", handleCookieChange);
    }

    return () => {
      isCancelled = true;
      document.removeEventListener("visibilitychange", syncAuthState);

      if ("cookieStore" in window) {
        cookieStore.removeEventListener("change", handleCookieChange);
      }
    };
  }, []);

  return isLoggedIn;
};
